import React from 'react';
import { useDispatch } from 'react-redux';
import { Typography } from '@tkww/the-bash-frontend';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

import SectionContainer from 'components/grid/SectionContainer';
import SearchForm from 'components/SearchForm';
import { BUTTON_CTA_STYLE, CTA_CLICK } from 'analytics/constants';

const VendorsSearch = () => {
  const dispatch = useDispatch();
  const theme = useTheme();

  const onSearchTrackingData = {
    name: CTA_CLICK,
    properties: {
      clickArea: 'Search Bar',
      clickTarget: 'Search',
      ctaStyle: BUTTON_CTA_STYLE,
    },
  };

  return (
    <SectionContainer
      sx={{
        paddingTop: 4,
        paddingBottom: 4,
      }}
      backgroundColor={theme.palette.grey[200]}
    >
      <Box
        component="section"
        sx={(theme) => ({
          padding: '32px 36px',
          backgroundColor: theme.palette.background.default,
        })}
      >
        <Typography variant="h2" mt={0} mb={5}>
          Ready To Find a Vendor?
        </Typography>
        <SearchForm
          showEventDateField={false}
          enableGeoLocation
          onSearchTrackingData={onSearchTrackingData}
        />
      </Box>
    </SectionContainer>
  );
};

export default VendorsSearch;
